var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.googleLoaded && _vm.appLoaded
    ? _c(
        "div",
        [
          _c("GmapMarker", {
            attrs: {
              icon: _vm.icon,
              position: {
                lat: parseFloat(_vm.location.latitude || _vm.location.lat),
                lng: parseFloat(_vm.location.longitude || _vm.location.lng)
              },
              clickable: true,
              draggable: false
            },
            on: {
              click: function($event) {
                return _vm.markerClicked()
              }
            }
          }),
          _vm._v(" "),
          _c(
            "GmapInfoWindow",
            {
              attrs: {
                opened: false,
                position: {
                  lat: parseFloat(_vm.location.latitude || _vm.location.lat),
                  lng: parseFloat(_vm.location.longitude || _vm.location.lng)
                },
                options: {
                  pixelOffset: _vm.pixelOffset || {
                    width: 0,
                    height: -40
                  }
                }
              },
              on: {
                closeclick: function($event) {
                  return _vm.markerClicked()
                }
              }
            },
            [
              _vm.location.id
                ? _c("p", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.formatAptNum(_vm.location)) +
                        " " +
                        _vm._s(
                          _vm.location.addressComponents.streetNumber.shortName
                        ) +
                        " " +
                        _vm._s(
                          _vm.location.addressComponents.streetName.shortName
                        ) +
                        ", "
                    ),
                    _c("br"),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.location.addressComponents.locality.shortName
                        ) +
                        " " +
                        _vm._s(
                          _vm.location.addressComponents.postalCode.shortName
                        ) +
                        "\n        " +
                        _vm._s(_vm.location.phone) +
                        "\n    "
                    )
                  ])
                : _vm._e()
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-375fb0b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-375fb0b4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/store-locator/GoogleMarkerInfoWindow.vue
// module id = null
// module chunks = 